import { render, staticRenderFns } from "./NewProjects.vue?vue&type=template&id=294622e0&scoped=true&"
import script from "./NewProjects.vue?vue&type=script&lang=js&"
export * from "./NewProjects.vue?vue&type=script&lang=js&"
import style0 from "./NewProjects.vue?vue&type=style&index=0&id=294622e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294622e0",
  null
  
)

export default component.exports